import PropTypes from 'prop-types';
import React from 'react';
import Popup from "reactjs-popup";

const popupContentStyle = {
  background: "var(--od-surface, #fff)",
  border: "none",
  borderRadius: "8px",
  boxShadow: "0 0 1px 1px rgba(0,0,0,0.02), 0 4px 6px 1px rgba(0,0,0,0.06)",
  width: "90%",
  maxWidth: "500px",
  padding: "20px"
};

const FolderDownloadModal = ({
  open,
  folder,
  humanFileSize,
  email,
  isSubmitting,
  onEmailChange,
  onClose,
  onDownload,
  onEmail
}) => (
  <Popup
    open={open}
    contentStyle={popupContentStyle}
    closeOnDocumentClick={false}
    onClose={onClose}
  >
    <div>
      <div className="row">
        <div className="col">
          <h5 className="modal-title-mb">
            <strong>Download folder?</strong>
          </h5>
        </div>
        <div className="col-xs-auto">
          <button
            type="button"
            className="btn btn-link text-dark popup-close-btn p-0"
            onClick={onClose}
            aria-label="Close"
          >
            <i className="far fa-times"></i>
          </button>
        </div>
      </div>

      <p className="mb-2">
        {folder.human_file_name} is about {humanFileSize}.
      </p>
      <p className="mb-3">
        Large downloads can take a while. You can download it now or email yourself a link when it's ready.
      </p>

      <div className="form-group">
        <label htmlFor="folder-download-email">Email link to</label>
        <input
          id="folder-download-email"
          type="email"
          className="form-control"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
        />
      </div>

      <div className="d-flex justify-content-end align-items-center">
        <button
          type="button"
          className="btn btn-link mr-2"
          onClick={onClose}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-outline-primary mr-2"
          onClick={onDownload}
          disabled={isSubmitting}
        >
          Download Now
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onEmail}
          disabled={isSubmitting || email.length === 0}
        >
          Email Link
        </button>
      </div>
    </div>
  </Popup>
);

FolderDownloadModal.propTypes = {
  open: PropTypes.bool.isRequired,
  folder: PropTypes.object,
  humanFileSize: PropTypes.string,
  email: PropTypes.string.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onEmail: PropTypes.func.isRequired
};

FolderDownloadModal.defaultProps = {
  folder: {},
  humanFileSize: ""
};

export default FolderDownloadModal;
